import { useState, useEffect } from "react";
import { FaBook, FaTrophy, FaBookmark, FaQuestionCircle } from "react-icons/fa";

export default function AnimatedNumber({ value, duration = 800 }) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const increment = value / (duration / 16); // ~60fps
        const timer = setInterval(() => {
            start += increment;
            if (start >= value) {
                start = value;
                clearInterval(timer);
            }
            setCount(Math.floor(start));
        }, 20);
        return () => clearInterval(timer);
    }, [value, duration]);

    return <span>{count}</span>;
}

